
export const toNumeric = (num) => {
    const re =/(\d{1,3})(?=(\d{3})+(?:$|\D))/g;
    return new String(num).replace(re, '$1,');
};

export const hasNumber = (num) => {
    const n = Number.parseInt(num, 10);
    return !isNaN(n) && n > 0;
};

